// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/PadreDashboard.css";

// const API_BASE =
//   process.env.REACT_APP_API_BASE || "http://localhost:5001/api";

// const DashboardPadre = () => {
//   const { token, user } = useAuth();

//   const [hijos, setHijos] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (token) {
//       cargarHijos();
//     }
//   }, [token]);

//   const cargarHijos = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const res = await axios.get(`${API_BASE}/padre/mis-hijos`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setHijos(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error("Error cargando hijos:", err);
//       setError("❌ No se pudieron cargar los estudiantes");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return <p className="padre-loading">⏳ Cargando estudiantes...</p>;
//   }

//   return (
//     <div className="padre-dashboard">
//       <h1 className="padre-title">
//         👨‍👩‍👧 Bienvenido {user?.nombre} {user?.apellido}
//       </h1>

//       <h3 className="padre-subtitle">
//         Estudiantes a tu cargo ({hijos.length})
//       </h3>

//       {error && <p className="padre-error">{error}</p>}

//       {hijos.length === 0 ? (
//         <p className="padre-empty">
//           No hay estudiantes registrados para este padre
//         </p>
//       ) : (
//         <div className="padre-lista">
//           {hijos.map((hijo) => (
//             <div
//               key={hijo.estudiante_id}
//               className="padre-card"
//             >
//               <h4>
//                 {hijo.nombres_estudiante} {hijo.apellidos_estudiante}
//               </h4>

//               <p>
//                 <strong>Documento:</strong>{" "}
//                 {hijo.documento_estudiante}
//               </p>

//               <p>
//                 <strong>Grado:</strong>{" "}
//                 {hijo.grado} {hijo.grupo}
//               </p>

//               <p>
//                 <strong>Sede:</strong>{" "}
//                 {hijo.sede_nombre || "N/A"}
//               </p>

//               <button
//                 className="padre-btn"
//                 onClick={() =>
//                   console.log(
//                     "Ver rendimiento del estudiante:",
//                     hijo.estudiante_id
//                   )
//                 }
//               >
//                 📊 Ver rendimiento
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default DashboardPadre;


////

import React, { useEffect, useState } from "react";
// 1. CORREGIDO: Usamos axiosAuth en lugar de axios puro
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/PadreDashboard.css";

const DashboardPadre = () => {
  const { token, user } = useAuth();

  const [hijos, setHijos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (token) {
      cargarHijos();
    }
  }, [token]);

  const cargarHijos = async () => {
    try {
      setLoading(true);
      setError("");

      // 2. CORREGIDO: Ruta relativa. 
      // axiosAuth ya sabe que la base es http://3.236.217.225/api
      const res = await axios.get("/padre/mis-hijos");

      setHijos(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error cargando hijos:", err);
      setError("❌ No se pudieron cargar los estudiantes a su cargo");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="padre-loading-container">
        <p className="padre-loading">⏳ Cargando información de estudiantes...</p>
      </div>
    );
  }

  return (
    <div className="padre-dashboard">
      <header className="padre-header">
        <h1 className="padre-title">
          👨‍👩‍👧 Bienvenido, {user?.nombre || "Padre de Familia"}
        </h1>
        <p className="padre-subtitle">
          Tienes <strong>{hijos.length}</strong> estudiante(s) vinculados a tu cuenta.
        </p>
      </header>

      {error && <p className="padre-error-msg">{error}</p>}

      {hijos.length === 0 ? (
        <div className="padre-empty-state">
          <p className="padre-empty">
            No se encontraron estudiantes registrados bajo su número de documento.
          </p>
          <small>Si cree que esto es un error, por favor contacte a la secretaría académica.</small>
        </div>
      ) : (
        <div className="padre-lista">
          {hijos.map((hijo) => (
            <div
              key={hijo.estudiante_id}
              className="padre-card"
            >
              <div className="padre-card-info">
                <h4>
                  {hijo.nombres_estudiante} {hijo.apellidos_estudiante}
                </h4>

                <p>
                  <strong>Documento:</strong>{" "}
                  {hijo.documento_estudiante}
                </p>

                <p>
                  <strong>Grado/Grupo:</strong>{" "}
                  <span className="badge-grado">
                    {hijo.grado}° {hijo.grupo}
                  </span>
                </p>

                <p>
                  <strong>Sede:</strong>{" "}
                  {hijo.sede_nombre || "Sede Principal"}
                </p>
              </div>

              <div className="padre-card-actions">
                <button
                  className="padre-btn"
                  onClick={() =>
                    console.log(
                      "Redirigiendo a rendimiento de:",
                      hijo.estudiante_id
                    )
                  }
                >
                  📊 Ver Rendimiento
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardPadre;